module.exports = __webpack_public_path__ + "static/media/I9P-03.d027dea2.svg";